import { usePreviewImage } from '@euler/app/components/media/ImageViewerContext';
import { Img } from '@euler/components/image/AdvancedImage';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { VehicleReport } from '@euler/model/report';
import { memo, useCallback } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

export const DashboardImageView = memo(
  ({
    report,
    style,
  }: {
    report: VehicleReport;
    style?: StyleProp<ViewStyle>;
  }) => {
    const preview = usePreviewImage();
    const { rpx } = useResponsiveContext();

    const onPress = useCallback(() => {
      if (!report.dashboardImgUrl) return;
      preview({ imageUrls: [report.dashboardImgUrl] });
    }, [preview, report.dashboardImgUrl]);

    if (!report.dashboardImgUrl) return null;

    return (
      <TouchableOpacity
        css={`
          border-radius: ${rpx(10)}px;
          overflow: hidden;
        `}
        onPress={onPress}
        style={style}
      >
        <Img
          uri={report.dashboardImgUrl}
          css={`
            flex: 1;
          `}
        />
      </TouchableOpacity>
    );
  },
);
